import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-6xl px-4 py-24 text-center">
        <div className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-brand-red">
          404
        </div>
        <h1 className="mb-4 font-serif text-3xl font-semibold tracking-tight md:text-4xl">
          Page not found
        </h1>
        <p className="mx-auto mb-6 max-w-md text-sm text-neutral-700 md:text-base">
          The page you are looking for does not exist. Please use the navigation or return
          to the homepage.
        </p>
        <Link
          to="/"
          className="inline-flex rounded-full bg-brand-red px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white hover:bg-red-700 transition-colors"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
};

export default NotFound;

